import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { DisplayProps } from 'styled-system';
import { Box, HStack, Span, VStack } from '@bpba/ui-components';
import { OTP_LABEL, OTP_LENGTH } from '../../../constants/form';
import OtpInput from 'react-otp-input';
import { StyledOTP } from './StyledOTP';
import { OtpError } from './OtpError';
import { Label } from '@bpba/form-components';

const ORDINAL_NUMBERS = ['primer', 'segundo', 'tercer', 'cuarto', 'quinto', 'sexto'];

const OTP_ERROR_ID = 'otp-err-msg';

type Props = {
  otp: string | undefined;
  setOtp: Dispatch<SetStateAction<string | undefined>>;
  onComplete?: () => void;
  ariaHidden: boolean;
  showError?: boolean;
} & DisplayProps;

export const FormularioOtp: FC<Props> = ({ otp, setOtp, onComplete, showError, ...otherProps }) => {
  useEffect(() => {
    if (onComplete && otp && otp.length === OTP_LENGTH) onComplete();
  }, [otp, onComplete]);

  return (
    <VStack {...otherProps} aria-hidden={otherProps.ariaHidden}>
      <Label label={OTP_LABEL} required={true} />

      <HStack marginBottom="4px" aria-required={true} aria-describedby={OTP_ERROR_ID} aria-invalid={showError} justifyContent={'center'}>
        <OtpInput
          value={otp}
          inputType="number"
          onChange={setOtp}
          numInputs={OTP_LENGTH}
          renderSeparator={
            <Span as={Box} mx={['4px', '8px']} color="secondary.1" width="auto" flexGrow={1} justifyContent="center" alignItems="center" fontSize={2}>
              -
            </Span>
          }
          renderInput={(props, index) => (
            <Box width="11.75%" height={0} paddingBottom="11.75%">
              <StyledOTP outlineColor={'tertiary.0'} {...props} aria-label={getInputLabel(index)} borderBottomWidth={'1px'} />
            </Box>
          )}
        />
      </HStack>

      <OtpError show={showError} id={OTP_ERROR_ID} otpLength={OTP_LENGTH} />
    </VStack>
  );
};
/** Se cambia aria-label para los inputs del OTP, ya que sino se leen en inglés. */
function getInputLabel(index: number) {
  return `Por favor ingrese el ${ORDINAL_NUMBERS[index]} número del código.`;
}
